const NoMatch = () => {
    return (
        <>
            <h2>Pagina niet gevonden.</h2>
        </>
    );
}

export default NoMatch;